import React from 'react'
export const selectBorrow = {
  path: (
    <g fill="none" key="OX9_PRatJ">
      <path
        key="BhyooO6DM"
        d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z"
        fill="#596F78"
      />
      <path
        opacity="0.7"
        key="0PW1X9QXHr"
        d="M18 30C24.6274 30 30 24.6274 30 18C30 14.3723 28.3903 11.1206 25.8462 8.92021M18 6C11.3726 6 6 11.3726 6 18C6 21.1668 7.22667 24.047 9.23077 26.1916"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        key="QAn5Pdu0G4"
        d="M20.4068 5.589C20.6938 5.78784 20.6938 6.21216 20.4068 6.411L18.0347 8.05439C17.7031 8.28413 17.25 8.0468 17.25 7.64339L17.25 4.35661C17.25 3.9532 17.7031 3.71587 18.0347 3.94561L20.4068 5.589Z"
        fill="white"
      />
      <path
        key="3wG6f3OSST"
        d="M14.5932 29.589C14.3062 29.7878 14.3062 30.2122 14.5932 30.411L16.9653 32.0544C17.2969 32.2841 17.75 32.0468 17.75 31.6434L17.75 28.3566C17.75 27.9532 17.2969 27.7159 16.9653 27.9456L14.5932 29.589Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        key="ZO3EfFhchQ"
        d="M20 15H22C22 12.7909 20.2091 11 18 11C15.7909 11 14 12.7909 14 15H16C16 13.8954 16.8954 13 18 13C19.1046 13 20 13.8954 20 15ZM12 18C12 16.8954 12.8954 16 14 16H22C23.1046 16 24 16.8954 24 18V23C24 24.1046 23.1046 25 22 25H14C12.8954 25 12 24.1046 12 23V18ZM19 19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19C17 18.4477 17.4477 18 18 18C18.5523 18 19 18.4477 19 19Z"
        fill="white"
      />
    </g>
  ),
  viewBox: '0 0 36 36',
}
